module.exports = __webpack_public_path__ + "assets/a22a113d6e8e8432b8f6a96583fe61cb.jpg";